jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    whenGsapReady(() => {
      whenScrollReady(() => {
        initProductDesc();
      });
    });
  });

  function initProductDesc() {
    const blocks = document.querySelectorAll(".js-nlp-desc");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    blocks.forEach((root) => {
      if (root.dataset.init === "1") return;
      root.dataset.init = "1";

      const top = Array.from(root.querySelectorAll(".js-nlp-desc-item")).filter(
        Boolean,
      );

      const listItems = Array.from(root.querySelectorAll(".js-nlp-desc-li"));
      const panel = root.querySelector(".js-nlp-desc-panel");
      const chips = Array.from(root.querySelectorAll(".js-nlp-desc-chip"));

      // Top text
      if (top.length) {
        gsap.set(top, { autoAlpha: 0, y: 18 });
        gsap.to(top, {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: "power2.out",
          stagger: 0.08,
          scrollTrigger: ScrollTrigger
            ? { trigger: root, start: "top 85%", once: true }
            : undefined,
        });
      }

      // Left list
      if (listItems.length) {
        gsap.set(listItems, { autoAlpha: 0, y: 14 });
        gsap.to(listItems, {
          autoAlpha: 1,
          y: 0,
          duration: 0.75,
          ease: "power2.out",
          stagger: 0.03,
          scrollTrigger: ScrollTrigger
            ? { trigger: root, start: "top 82%", once: true }
            : undefined,
        });
      }

      // Right panel
      if (panel) {
        gsap.set(panel, { autoAlpha: 0, scale: 0.985 });
        gsap.to(panel, {
          autoAlpha: 1,
          scale: 1,
          duration: 0.95,
          ease: "power2.out",
          scrollTrigger: ScrollTrigger
            ? { trigger: root, start: "top 82%", once: true }
            : undefined,
        });
      }

      // Chips
      if (chips.length) {
        gsap.set(chips, { autoAlpha: 0, y: 10 });
        gsap.to(chips, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          ease: "power2.out",
          stagger: 0.02,
          scrollTrigger: ScrollTrigger
            ? { trigger: root, start: "top 78%", once: true }
            : undefined,
        });
      }
    });
  }
});
